export default {
  // Custom statuses
  LOADING: 'LOADING',
  FAILED: 'FAILED',
  // Statuses from backend
  CREATED: 'CREATED',
  UPLOADED: 'UPLOADED',
  DELETED: 'DELETED',
  REJECTED: 'REJECTED',
};
